// shared
import { country, state, validString } from "Components/shared/helpers/validations"
// helpers
import { reverseShape } from "Helpers/reverse-shape"
// validations
import { addressLine, email, fullContact, gender, idType, nric, passport, postcode } from "Utils/validations"
// yup
import * as Yup from "yup"

const UserDetailsSchema = Yup.object().shape(
    reverseShape({
        fullName: validString.required(),
        idPassportType: idType.required(),
        idPassportNo: Yup.mixed().when("idPassportType", {
            is: "NRIC",
            then: nric.required(),
            otherwise: passport.required(),
        }),
        mobileNo: fullContact.required(),
        email: email.required(),
        street1: addressLine.required(),
        street2: addressLine.optional(),
        postcode: postcode.required(),
        city: validString.required(),
        country: country.required(),
        state: state.required(),
        gender: gender.required(),
    })
)

export default UserDetailsSchema
